const iniciarMouseFlow = (urlMouseflow) => {
  if (process.browser) {
    window._mfq = window._mfq || []
    const mf = document.createElement('script')
    mf.type = 'text/javascript'
    mf.defer = true
    mf.src = urlMouseflow
    document.getElementsByTagName('head')[0].appendChild(mf)
  }
}

export { iniciarMouseFlow }
